import { useState, useEffect, forwardRef } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  Grid,
  TextField,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";

import { toast } from "../../../utilities/SnackBarUtils";
import request from "../../../utilities/requests";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DeploymentDialog = ({ deployment, close }) => {
  const [open, setOpen] = useState(false);

  // Customization state
  const [title, setTitle] = useState("");
  const [primaryColor, setPrimaryColor] = useState("");
  const [logoUrl, setLogoUrl] = useState("");
  const [faviconUrl, setFaviconUrl] = useState("");
  const [fromEmail, setFromEmail] = useState("");
  const [ccEmail, setCCEmail] = useState("");
  const [privacyPolicy, setPrivacyPolicy] = useState("");

  useEffect(() => {
    if (deployment) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [deployment]);

  useEffect(() => {
    if (deployment && deployment.style) {
      setTitle(deployment.style.title || "");
      setPrimaryColor(deployment.style.primaryColor || "");
      setLogoUrl(deployment.style.logo || "");
      setFaviconUrl(deployment.style.favicon || "");
      setFromEmail(deployment.fromEmail || "");
      setCCEmail(deployment.ccEmail || "");
      setPrivacyPolicy(deployment.privacyPolicy || "");
    }
  }, [deployment]);

  const handleSave = async () => {
    const body = {
      deploymentId: deployment._id,
      update: {
        title,
        primaryColor,
        fromEmail,
        ccEmail,
        privacyPolicy
      },
    };
    const result = await request("orgs/updatedeployment", "post", body);
    if (result.success) {
      toast.success("Site config updated successfully");
      handleClose();
    }
  };

  const handleUpload = async (imageType, event) => {
    const file = event.target.files[0];
    const body = new FormData();
    body.append(imageType, file);
    body.append("Content-Type", "image/jpg");
    body.append("deploymentId", deployment._id);
    body.append("imageType", imageType);

    const token = localStorage.getItem(`${process.env.REACT_APP_COGNITO_CLIENT_ID}.accessToken`);
    // setLoading(true);
    axios({
      url: `${process.env.REACT_APP_TNFT_SERVER}/orgs/uploadimage`,
      method: "post",
      data: body,
      headers: { "Content-Type": "multipart/form-data", Accesstoken: token },
    })
      .then((response) => {
        if (response?.data?.success) {
          if (imageType === "logo") {
            setLogoUrl(response?.data?.imageUrl);
          } else if (imageType === "favicon") {
            setFaviconUrl(response?.data?.imageUrl);
          }
          return;
        }
      })
      .catch((response) => {
        console.error(response);
        toast.error(response?.response?.data?.error);
      });
  };

  const handleClose = () => {
    close();
    setTitle("");
    setPrimaryColor("");
    setFaviconUrl("");
    setLogoUrl("");
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Site Settings
          </Typography>
          <Button autoFocus color="inherit" onClick={handleSave}>
            save
          </Button>
        </Toolbar>
      </AppBar>
      <DialogContent>
        <Grid container spacing={3} style={{ padding: 16 }}>
          <Grid item xs={16}>
            <TextField
              label="Title"
              fullWidth
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Primary Color"
              fullWidth
              value={primaryColor}
              onChange={(e) => setPrimaryColor(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="From Email"
              fullWidth
              value={fromEmail}
              onChange={(e) => setFromEmail(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="CC Email"
              fullWidth
              value={ccEmail}
              onChange={(e) => setCCEmail(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Privacy Policy Link"
              fullWidth
              value={privacyPolicy}
              onChange={(e) => setPrivacyPolicy(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <Divider sx={{ my: 2 }} />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">Logo</Typography>
            {logoUrl && (
              <img
                src={logoUrl}
                alt="Logo Preview"
                style={{ maxHeight: 200, display: "block", marginBottom: 8 }}
              />
            )}
            <Button variant="contained" component="label">
              Upload Logo
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={(e) => handleUpload("logo", e)}
              />
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Divider sx={{ my: 2 }} />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">Favicon</Typography>
            {faviconUrl && (
              <img
                src={faviconUrl}
                alt="Favicon Preview"
                style={{ maxHeight: 60, display: "block", marginBottom: 8 }}
              />
            )}
            <Button variant="contained" component="label">
              Upload Favicon
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={(e) => handleUpload("favicon", e)}
              />
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          padding: 20,
        }}
      >
        <Button
          onClick={handleSave}
          variant="contained"
          style={{ width: "80%" }}
        >
          Save
        </Button>
      </div>
    </Dialog>
  );
};

export default DeploymentDialog;
